export const validateDeliveryCreation = (values) => {
  const errors = {};
  if (Number(values.type) === 7) {
    errors.comments = !values.comments ? 'Value is required' : null;
  }
  if (
    (!values.recipients || !values.recipients.length) &&
    (!values.units || !values.units.length)
  ) {
    errors.recipients = 'One or more recipient is required';
    errors.units = 'One or more recipient is required';
  }
  return errors;
};

export const getDeliveryTypeIcon = (deliveryTypes, deliveryTypeId) =>
  deliveryTypes?.find((dt) => Number(dt.id) === Number(deliveryTypeId))
    ?.icons?.[0]?.url;
